import {useFacialBiometricsStore} from 'presentation/modules/booking/shared/store/useFacialBiometricsStore';
import {useFacialBiometricFeatureFlag} from './useFacialBiometricFeatureFlag';
import {useAccountInformation} from './useAccountInformation';

export function useShowFacialBiometric() {
	const {isEnabled: isFacialBiometricEnabled} = useFacialBiometricFeatureFlag();
	const {odontoOnly} = useAccountInformation();
	const {isTea, guardians} = useFacialBiometricsStore(state => state);

	const hasRegisteredGuardian = (guardians ?? []).some(guardian => guardian.facialRegistered);

	if (isTea && hasRegisteredGuardian) {
		return false;
	}

	return isFacialBiometricEnabled && !odontoOnly;
}
